import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { DEVAPI_BUILD, LOCAL_AUTH, PRODUCTION_BUILD } from '../app.settings';
import {
    APP_URL_EPC,
    APP_URL_ETD, APP_URL_HELIOS,
    APP_URL_HELPDESK,
    APP_URL_ISBN,
    APP_URL_LIBADMIN,
    APP_URL_ROOMBOOK,
    APP_URL_TOOLS,
    APP_URL_UIK,
    APP_URL_ZP,
    AUTH_REDIRECT_URL,
    BASE_COOKIE_DOMAIN,
    LOCAL_FRONTEND_URL,
} from '../app.urls';
import { AUTH_RETURN_URL_COOKIE_EXPIRATION } from '../constants';

@Injectable()
export class AppRedirectService {
    constructor(
        private router: Router,
        private cookieService: CookieService,
        @Inject(DOCUMENT) private document: any
    ) {}

    redirectLogin(sendReturnUrl: boolean = false): void {
        if (!PRODUCTION_BUILD && !DEVAPI_BUILD && !LOCAL_AUTH) {
            this.document.location.href =
                AUTH_REDIRECT_URL +
                '?development=true&redirectAfterLogin=' +
                encodeURIComponent(LOCAL_FRONTEND_URL + '/#/dev');
        } else {
            if (sendReturnUrl) {
                const expires = Date.now() + AUTH_RETURN_URL_COOKIE_EXPIRATION;
                this.cookieService.set(
                    'auth_ret',
                    encodeURIComponent(this.document.location.href),
                    expires,
                    '/',
                    BASE_COOKIE_DOMAIN,
                    PRODUCTION_BUILD ? true : false,
                    'Strict',
                );
            } else if (this.cookieService.check('auth_ret')) {
                this.cookieService.delete('auth_ret', '/', BASE_COOKIE_DOMAIN);
            }

            this.document.location.href = AUTH_REDIRECT_URL;
        }
    }

    redirect(url: string): void {
        this.document.location.href = url;
    }

    redirectEpc(): void {
        this.document.location.href = APP_URL_EPC;
    }

    redirectEtd(): void {
        this.document.location.href = APP_URL_ETD;
    }

    redirectIsbn(): void {
        this.document.location.href = APP_URL_ISBN;
    }

    redirectHelios(): void {
        this.document.location.href = APP_URL_HELIOS;
    }

    redirectRoombook(): void {
        this.document.location.href = APP_URL_ROOMBOOK;
    }

    redirectZp(): void {
        this.document.location.href = APP_URL_ZP;
    }

    redirectUik(): void {
        this.document.location.href = APP_URL_UIK;
    }

    redirectHelpdesk(): void {
        this.document.location.href = APP_URL_HELPDESK;
    }

    redirectTools(): void {
        this.document.location.href = APP_URL_TOOLS;
    }

    redirectLibadmin(): void {
        this.document.location.href = APP_URL_LIBADMIN;
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/services/app-redirect.service.ts